export default __webpack_public_path__ + "static/media/checkMark.df848f6c.gif";